export const GMB_MEDIA_STATUS = {
  PENDING: 1,
  COMPLETED: 2,
  FINISHED_WITH_PROBLEMS: 3
};
